export const COLORS = {
  bgColor: '#f7f7f7',
  bgColorBlogs: '#F4F7FF',
  bgBlue: ' rgba(64, 119, 255, 0.10)',
  lightGray: '#9A9EA6',
  placeholder: '#9A9EA6',
  greenPrimary: '#1F9638',
  borderColor: '#E8ECF4',
  tableRowBackgroundColor: '#E7ECF5',
  textSecondary: '#676D75',
  borderDark: '#71767D',
  white: '#FFFFFF',
  black: '#000000',
  inputPlaceholderColor: '#A9ADB2',
  primary: '#0B3C95',
  primaryDark: '#082B6E',
  dividerColor: 'rgba(0, 0, 0, 0.12)',
  applicationItemBorder: 'rgba(0, 0, 0, 0.20)',
  applicationItemBg: '#F9F9F9',
  skyBlue: '#4BB3FD',
  mustard: '#FFBA08',
  purple: '#802BFF',
  filtersColor: '#7F8184'
};
